import { get } from 'lodash';
import { defaultBodyBorderColor, defaultBodyBorderStyle, } from '../message-defaults';
import { toRgbAsHex } from '../color';
import { getBodyBorderWidth } from './get-body-border-width';
export var getBodyBorder = function (composerData) {
    var borderWidth = getBodyBorderWidth(composerData);
    if (borderWidth === 0) {
        return '0';
    }
    var borderColor = toRgbAsHex(get(composerData, 'background.body.borderColor') ||
        get(composerData, 'styles.css.so-global-body.borderColor') ||
        defaultBodyBorderColor);
    var borderStyle = get(composerData, 'background.body.borderStyle') ||
        get(composerData, 'styles.css.so-global-body.borderStyle') ||
        defaultBodyBorderStyle;
    return borderStyle + " " + borderWidth + "px " + borderColor;
};
//# sourceMappingURL=get-body-border.js.map